import { FieldError, UseFormRegisterReturn } from 'react-hook-form'
import TextField, { TextSize } from '../../atoms/inputs/TextField'

type FullNameFieldProps = {
  register?: UseFormRegisterReturn
  size?: TextSize
  error?: FieldError
  disabled?: boolean
}

export default function FullNameField({ register, size, error, disabled }: FullNameFieldProps) {
  return (
    <TextField
      register={register}
      placeholder="請求 太郎"
      size={size ?? 'sm'}
      error={error?.message}
      readonly={disabled}
    />
  )
}
